import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { ToastProvider, TooltipProvider } from '@agency/ui';
import './styles.css';
import { SessionProvider } from './lib/session.js';
import { router } from './routes.js';

const container = document.getElementById('root');
if (!container) throw new Error('missing #root element');

createRoot(container).render(
  <StrictMode>
    <TooltipProvider>
      <ToastProvider>
        <SessionProvider>
          <RouterProvider router={router} />
        </SessionProvider>
      </ToastProvider>
    </TooltipProvider>
  </StrictMode>,
);
